import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import {fromAPI} from './model';

/*
    CRUD API

    NOTE: forChildren and forEmployees are always enabled for the time being.
    The backend fully supports disabled statuses for either, but we've skipped the frontend impl. for now
 */
export const fetch = institutionId =>
    RESTClient.getAuthenticatedObservable('v2/status/configs', {institutionId}).map(({statusConfigs, behaviors}) => ({
        statuses: List(statusConfigs).map(fromAPI),
        behaviors: new BehaviorsCollection(behaviors),
    }));

export const update = (statusConfigId, icon, color, title) =>
    RESTClient.putAuthenticatedObservable(`v2/status/configs/${statusConfigId}`, {
        statusConfig: {
            statusConfigId,
            icon,
            color,
            title,
            forChildren: true,
            forEmployees: true,
        },
    }).map(response => fromAPI(response.statusConfig));

export const create = (institutionId, icon, color, title) =>
    RESTClient.postAuthenticatedObservable('v2/status/configs', {
        statusConfig: {
            institutionId,
            icon,
            color,
            title,
            forChildren: true,
            forEmployees: true,
        },
    }).map(response => fromAPI(response.statusConfig));

export const remove = statusConfigId => RESTClient.deleteAuthenticatedObservable(`v2/status/configs/${statusConfigId}`);

/*
    API for starting and ending statuses on people
 */
export const applyStatus = (statusConfigId, childIds, employeeIds) =>
    RESTClient.postAuthenticatedObservable(`v2/status/configs/${statusConfigId}/registrations`, {
        childIds,
        employeeIds,
    });

export const endStatus = (statusConfigId, childIds, employeeIds) =>
    RESTClient.postAuthenticatedObservable(`v2/status/configs/${statusConfigId}/registrations/end`, {
        childIds,
        employeeIds,
    });

/*
    API for enabling and disabling HIDE_CUSTOM_STATUS_CHILD_ACTIVITY feature
*/
const hideCustomStatusFeatureFlag = 'HIDE_CUSTOM_STATUS_CHILD_ACTIVITY';
export const enableHideCustomStatusChildActivity = institutionId =>
    RESTClient.postAuthenticatedObservable(`v2/features/${institutionId}`, {
        feature: hideCustomStatusFeatureFlag,
    });

export const disableHideCustomStatusChildActivity = institutionId =>
    RESTClient.deleteAuthenticatedObservable(`v2/features/${institutionId}/${hideCustomStatusFeatureFlag}`);
